const setTimeoutCheckLogin = function (ids, colorList) {
	setTimeout(() => 
		axios.get('/documents/is_login')
		.then(res => {
			if (res.data.result) {
				setTimeoutCheckLogin();
				reutrn;
			}
			alert('セッションタイムアウトが発生しました。ログアウト画面に遷移します。');
			window.location.href = '/documents/logout';
		})
		.catch(function (response) {
			// console.log(response);
		})
	, (5*60*1000));
};

export { setTimeoutCheckLogin };